import type { Address, AddressCriteria } from '~/utils/ct';

function isKeyOfAddress(key: string, address: Address): key is keyof Address {
  return key in address;
}

function getAddresses(addresses: Maybe<Address[]>, criteria?: AddressCriteria): Address[] {
  if (!addresses || !addresses.length) {
    return [];
  }
  if (!criteria || !Object.keys(criteria).length) {
    return addresses;
  }

  const entries = Object.entries(criteria);
  return addresses.filter(address =>
    entries.every(([key, value]) => {
      if (isKeyOfAddress(key, address)) {
        return address[key] === value;
      }
      return false;
    }),
  );
}

function getDefault(addresses: Maybe<Address[]>, defaultId: Maybe<string>): Address | undefined {
  return addresses?.find(({ id }) => id === defaultId);
}

function getTotal(addresses: Maybe<Address[]>): number {
  return addresses?.length || 0;
}

function getPostCode(address: Partial<Address>): string {
  return address?.postalCode || '';
}

function getStreetName(address: Partial<Address>): string {
  return address?.streetName || '';
}

function getStreetNumber(address: Partial<Address>): string {
  return address?.streetNumber || '';
}

function getCity(address: Partial<Address>): string {
  return address?.city || '';
}

function getFirstName(address: Partial<Address>): string {
  return address?.firstName || '';
}

function getLastName(address: Partial<Address>): string {
  return address?.lastName || '';
}

function getCountry(address: Partial<Address>): string {
  return address?.country || '';
}

function getPhone(address: Partial<Address>): string {
  return address?.phone || '';
}

function getEmail(address: Partial<Address>): string {
  return address?.email || '';
}

function getProvince(address: Partial<Address>): string {
  return address?.state || '';
}

function getCompanyName(address: Partial<Address>): string {
  return address?.company || '';
}

function getId(address: Partial<Address>): string {
  return address?.id || '';
}

function getApartmentNumber(address: Partial<Address>): string {
  return address?.apartment || '';
}

export const userAddressGetters = {
  getAddresses,
  getDefault,
  getTotal,
  getPostCode,
  getStreetName,
  getStreetNumber,
  getCity,
  getFirstName,
  getLastName,
  getCountry,
  getPhone,
  getEmail,
  getProvince,
  getCompanyName,
  getId,
  getApartmentNumber,
};
